import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "../../components/feature/Navbar";
import DiagnosticVideo from "../../components/feature/DiagnosticVideo";
import Footer from "../../components/feature/Footer";
import FloatingButton from "../../components/feature/FloatingButton";
import Avis from "../../components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import PanneProfalux from "./components/PanneProfalux";
import RemplacementMoteur from "./components/RemplacementMoteur";
import QuelMoteur from "./components/QuelMoteur";
import AutresMarques from "./components/AutresMarques";
import ReparerPlutot from "./components/ReparerPlutot";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function MoteurProfalux() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Moteur Profalux Strasbourg | Remplacement Volet"
        description="Remplacement de moteur Profalux pour volet roulant à Strasbourg et dans le Bas-Rhin. Fils conducteurs WireFree, tabliers électriques, radio. Devis gratuit. 03 74 47 32 40."
        path="/moteur-profalux"
        type="service"
        serviceType="Remplacement de moteur Profalux"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Moteur Profalux" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Moteur Profalux" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <PanneProfalux />
        <RemplacementMoteur />
        <QuelMoteur />
        <AutresMarques />
        <ReparerPlutot />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}